namespace TabAurous.ECommerce {
    export interface ECommSalesForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        AutoPosting: Serenity.BooleanEditor;
        VoucherNo: Serenity.StringEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        PartyId: Serenity.IntegerEditor;
        CustomerName: Serenity.StringEditor;
        Mobile: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        BirthDate: Serenity.DateEditor;
        Anniversary: Serenity.DateEditor;
        TaxId: Serenity.StringEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.LookupEditor;
        ImageName: Serenity.ImageUploadEditor;
        BillingAddress: Serenity.StringEditor;
        BillingCountryName: Serenity.StringEditor;
        BillingStateName: Serenity.StringEditor;
        BillingCityName: Serenity.StringEditor;
        BillingPin: Serenity.StringEditor;
        BillingPhone: Serenity.StringEditor;
        BillingCity: Serenity.IntegerEditor;
        BillingState: Serenity.IntegerEditor;
        BillingCountry: Serenity.IntegerEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        ShippingAddress: Serenity.StringEditor;
        ShippingCountry: Serenity.LookupEditor;
        ShippingState: Serenity.LookupEditor;
        ShippingCity: Serenity.LookupEditor;
        ShippingPincode: Serenity.StringEditor;
        ShippingPhone: Serenity.StringEditor;
        ShippingCityName: Serenity.StringEditor;
        ShippingStateName: Serenity.StringEditor;
        ShippingCountryName: Serenity.StringEditor;
        ItemDetails: ECommSalesItemsEditor;
        GiftDetails: ECommSalesGiftVoucherEditor;
        PromoDetails: ECommSalesPromoEditor;
        TaxDetails: ECommSalesTaxEditor;
        ReceiptDetails: ECommSalesReceiptEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxAmount: AmountEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        RoundOff: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Receipt: Serenity.DecimalEditor;
        BalanceAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        FinancialYearId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class ECommSalesForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.ECommSales';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ECommSalesForm.init)  {
                ECommSalesForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.ServiceLookupEditor;
                var w5 = s.IntegerEditor;
                var w6 = s.LookupEditor;
                var w7 = s.DecimalEditor;
                var w8 = s.ImageUploadEditor;
                var w9 = ECommSalesItemsEditor;
                var w10 = ECommSalesGiftVoucherEditor;
                var w11 = ECommSalesPromoEditor;
                var w12 = ECommSalesTaxEditor;
                var w13 = ECommSalesReceiptEditor;
                var w14 = AmountEditor;
                var w15 = s.TextAreaEditor;

                Q.initFormType(ECommSalesForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'AutoPosting', w3,
                    'VoucherNo', w2,
                    'POSCustomerId', w4,
                    'PartyId', w5,
                    'CustomerName', w2,
                    'Mobile', w2,
                    'Email', w2,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'BirthDate', w0,
                    'Anniversary', w0,
                    'TaxId', w2,
                    'CurrencyId', w6,
                    'ExchRate', w7,
                    'UserId', w6,
                    'EmployeeId', w6,
                    'ImageName', w8,
                    'BillingAddress', w2,
                    'BillingCountryName', w2,
                    'BillingStateName', w2,
                    'BillingCityName', w2,
                    'BillingPin', w2,
                    'BillingPhone', w2,
                    'BillingCity', w5,
                    'BillingState', w5,
                    'BillingCountry', w5,
                    'VoucherTypeId', w5,
                    'ShippingAddress', w2,
                    'ShippingCountry', w6,
                    'ShippingState', w6,
                    'ShippingCity', w6,
                    'ShippingPincode', w2,
                    'ShippingPhone', w2,
                    'ShippingCityName', w2,
                    'ShippingStateName', w2,
                    'ShippingCountryName', w2,
                    'ItemDetails', w9,
                    'GiftDetails', w10,
                    'PromoDetails', w11,
                    'TaxDetails', w12,
                    'ReceiptDetails', w13,
                    'Pieces', w5,
                    'Weight', w7,
                    'NetWeight', w7,
                    'NetAmount', w7,
                    'TaxAmount', w14,
                    'Discount', w7,
                    'AdditionalCharges', w7,
                    'RoundOff', w7,
                    'GrossAmount', w7,
                    'Receipt', w7,
                    'BalanceAmount', w7,
                    'Remark', w15,
                    'FinancialYearId', w5,
                    'CompanyId', w5
                ]);
            }
        }
    }
}
